import { takeLatest, call, put } from "redux-saga/effects";
import { getCalendarEvents } from "../../api/firestore/calendar";
import {
  sagaApiActionsConstructor,
  sagaApiListenerConstructor,
} from "../helpers";

const { requestStart, requestError, requestSuccess } =
  sagaApiActionsConstructor("chat");

// alerts
function* initCalendarSaga({}) {}

function* getMainEventsSaga({}) {
  try {
    yield requestStart();
    const events = yield call(getCalendarEvents);

    yield put({
      type: "calendar/setMainEvents",
      payload: { events: Object.values(events) },
    });
  } catch (e) {
    console.log(e);
    yield requestError(e);
  }
}

function* modalRootSaga() {
  yield takeLatest("calendar/init", initCalendarSaga);
  yield takeLatest("calendar/getMainEvents", getMainEventsSaga);
}

export default modalRootSaga;
